import React from "react";
import { Tooltip } from "@mui/material";
import infoIcon from "assets/svg/infoIcon.svg";
import warningIcon from "assets/svg/warningTriangleIcon.svg";

export type ITooltipPlacement =
  | "bottom-end"
  | "bottom-start"
  | "bottom"
  | "left-end"
  | "left-start"
  | "left"
  | "right-end"
  | "right-start"
  | "right"
  | "top-end"
  | "top-start"
  | "top";

type Props = {
  title?: string | React.ReactNode;
  placement?: ITooltipPlacement;
  maxWidth?: string;
  iconStyles?: React.CSSProperties;
  icon?: "info" | "warning";
};

const ICON_SRC = {
  info: infoIcon,
  warning: warningIcon,
};

export const InfoTooltip = ({
  title,
  placement = "right",
  maxWidth,
  iconStyles,
  icon = "info",
}: Props) => {
  return (
    <Tooltip
      title={title}
      arrow
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth,
          },
        },
      }}
    >
      <img
        src={ICON_SRC[icon]}
        alt={icon}
        style={{
          width: "14px",
          height: "14px",
          marginLeft: "5px",
          cursor: "pointer",
          ...iconStyles,
        }}
      />
    </Tooltip>
  );
};
